import { Loader } from '../../Loader';

export const LoaderContainer = () => (
    <div className="loader-container">
        <Loader />
    </div>
)